import React, { useRef } from "react"
import Styles from "../styles/RightColumn.module.scss";

export const RightColumn = ( {
    children
}: { children: JSX.Element } ) =>
    <div className={ Styles.container }>
        <div className={ Styles.content }>
            { children }
        </div>
    </div>
